(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flower-bulb-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("flower-bulb-calculator")) {
    class FlowerBulbCalculator extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;
        this.content = this.querySelector("[data-calculator-content]");
        this.toggleButton = this.querySelector("[data-calculator-toggle]");
        this.toggleLabel = this.querySelector("[data-calculator-toggle-label]");
        this.areaInput = this.querySelector("[data-area-input]");
        this.decreaseButton = this.querySelector("[data-area-decrease]");
        this.increaseButton = this.querySelector("[data-area-increase]");
        this.result = this.querySelector("[data-calculator-result]");
        this.densityOptions = this.querySelectorAll("[data-density-option]");
        this.plantsPerSqm = this.toPositiveNumber(this.dataset.plantsPerSqm);
        this.densityRatio = this.toPositiveNumber(this.dataset.densityRatio) || 1.5;

        this.handleToggle = () => this.setOpen(!this.hasAttribute("open"));
        this.handleDecrease = () => this.adjustArea(-1);
        this.handleIncrease = () => this.adjustArea(1);
        this.handleAreaInput = () => this.calculate();
        this.handleAreaBlur = () => this.normalizeArea();
        this.handleDensityChange = () => this.calculate();

        this.toggleButton?.addEventListener("click", this.handleToggle);
        this.decreaseButton?.addEventListener("click", this.handleDecrease);
        this.increaseButton?.addEventListener("click", this.handleIncrease);
        this.areaInput?.addEventListener("input", this.handleAreaInput);
        this.areaInput?.addEventListener("blur", this.handleAreaBlur);
        this.densityOptions.forEach((option) =>
          option.addEventListener("change", this.handleDensityChange),
        );

        this.setOpen(false);
        this.calculate();
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener("click", this.handleToggle);
        this.decreaseButton?.removeEventListener("click", this.handleDecrease);
        this.increaseButton?.removeEventListener("click", this.handleIncrease);
        this.areaInput?.removeEventListener("input", this.handleAreaInput);
        this.areaInput?.removeEventListener("blur", this.handleAreaBlur);
        this.densityOptions?.forEach((option) =>
          option.removeEventListener("change", this.handleDensityChange),
        );
        this.initialized = false;
      }

      toPositiveNumber(value) {
        const number = Number(value);
        return Number.isFinite(number) && number > 0 ? number : null;
      }

      setOpen(isOpen) {
        this.toggleAttribute("open", isOpen);
        this.toggleButton?.setAttribute("aria-expanded", String(isOpen));
        this.content?.setAttribute("aria-hidden", String(!isOpen));
        this.content?.toggleAttribute("inert", !isOpen);

        if (this.toggleLabel) {
          this.toggleLabel.textContent = isOpen
            ? this.dataset.closeLabel
            : this.dataset.openLabel;
        }
      }

      getArea() {
        return this.toPositiveNumber(this.areaInput?.value);
      }

      normalizeArea() {
        const area = Math.max(1, Math.round(this.getArea() || 1));

        if (this.areaInput) {
          this.areaInput.value = area;
        }

        this.calculate();
      }

      adjustArea(change) {
        const area = Math.max(1, Math.round(this.getArea() || 1) + change);

        if (this.areaInput) {
          this.areaInput.value = area;
        }

        this.calculate();
      }

      calculate() {
        const area = this.getArea();
        const selectedDensity = this.querySelector(
          "[data-density-option]:checked",
        )?.value;
        const multiplier = selectedDensity === "full" ? this.densityRatio : 1;
        const roundingStep = selectedDensity === "full" ? 10 : 1;
        const calculatedTotal = area * this.plantsPerSqm * multiplier;
        const total =
          area && this.plantsPerSqm
            ? Math.ceil(calculatedTotal / roundingStep) * roundingStep
            : 0;

        if (this.result) {
          this.result.textContent = String(total);
        }

        if (this.decreaseButton) {
          this.decreaseButton.disabled = !area || area <= 1;
        }
      }
    }

    customElements.define("flower-bulb-calculator", FlowerBulbCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
